import ButtonLink from 'sd-ui/dist/commonjs/components/ButtonLink/ButtonLink';
import PropTypes from 'prop-types';

const EnhancementSliderButton = (props) => {
  const {
    children,
    className,
    icon,
    onClick,
    render,
  } = props;

  return render ? (
    <div
      className={`enhancement-slider-button ${className}`}
    >
      <ButtonLink
        className="button-link-secondary button-link-icon"
        icon={icon}
        onClick={onClick}
      >
        <span className="u-hide-visually">
          {children}
        </span>
      </ButtonLink>
    </div>
  ) : null;
};

EnhancementSliderButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired,
  render: PropTypes.bool,
};

EnhancementSliderButton.defaultProps = {
  children: null,
  render: false,
};

export default EnhancementSliderButton;
